import { adminEndpoints } from "@src/services/endpoints";
import { queryClient } from "@src/utils/queryClient";

const adminLoader = async () => {
  // this is the required data that must be loaded to render the ADMIN module
  const data = queryClient.ensureQueryData({
    queryKey: ["ADMIN_CUSTOMERS"],
    //staleTime: STALE_TIME_1HS,
    queryFn: async () => adminEndpoints.getCustomers(),
  });
  return data;
};

export default adminLoader;
